import { apiGateway, api } from "../config";
import {AxiosInstance, AxiosPromise} from "axios";

class warehousesService {

    async createNewWarehouse<T>(data: T) {
        console.log('addNewWarehouse', JSON.stringify(data));

        return api(apiGateway.warehouses, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    async updateWarehouse<T>(uuid: string, data: T) {
        console.log('updateWarehouse жиесть', JSON.stringify(data));

        return api(`${apiGateway.warehouses}/${uuid}`, {
            method: "POST",
            headers: {
                Accept:         "application/json, text/plain, */*",
                "Content-Type": "application/json",
            },
            // @ts-ignore
            data: JSON.stringify(data)
        })
    }

    getWarehousesForSeller(sellerId: number): Promise<any> {

        // @ts-ignore
        if (!window.sellerWarehouses) {
            // @ts-ignore
            window.sellerWarehouses = {}
        }
        // @ts-ignore
        if (!Array.isArray(window.sellerWarehouses[sellerId])) {
            // @ts-ignore
            window.sellerWarehouses[sellerId] = api(`${apiGateway.warehouses}?sellerID=${sellerId}`, {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            })
        }

        // @ts-ignore
        return window.sellerWarehouses[sellerId]
    }

    getWarehouseByUUID(uuid: string) {
        return api(`${apiGateway.warehouses}/${uuid}`, {
            method: "GET",
            headers: {
                "Cache-Control": "no-cache"
            }
        })
    }

}

export default new warehousesService();